import { queryOptions } from "@tanstack/react-query";
import { apiGet } from "@softmax/observatory-client/client";
import type { FlagsResponse } from "@softmax/observatory-client/types";

export const siteFlagsQueryOptions = () =>
  queryOptions({
    queryKey: ["flags", "me", { elevatedPrivileges: false }],
    queryFn: ({ signal }) =>
      apiGet<FlagsResponse>("/flags/me", {
        elevatedPrivileges: false,
        signal,
      }),
    staleTime: 30_000,
  });
